import React from "react";
import { Button, Col, Row, Tab, Tabs } from "react-bootstrap";
import { browserName } from "react-device-detect";
import DocumentMeta from "react-document-meta";
import { useLocation } from "react-router";
import { Link } from "react-router-dom";
import HeaderBanner from "../Components/HeaderBanner";
import Config from "../config.json";
import Addon from "../Images/add-on.png";
import Chrome from "../Images/chrome.png";
import FireFox from "../Images/firefox.png";
import edge from "../Images/edge.png";

const body = (
  <>
    به شما امکان می‌دهد صفحات وب، کتاب، مقالات تخصصی و منابع دیگر را
    <br /> از طریق وب‌گاه‌های اطلاعات کتابشناختی و کتابخانه‌ای به کتابخانه
    پژوهیار اضافه کنید. <br />
    این افزونه ها برای سه مرورگر پر کاربرد کروم، فایرفاکس و Edge فراهم شده است.
    </>
);

const title = "افزونه مرورگرهای پژوهیار";

const page_meta = {
  language: "fa",
  copyright: "پژوهیار",
  description: "نرم‌افزار استناددهی",
  title: Config.title + " | افزونه مرورگر",
  meta: {
    charset: "utf-8",
    name: {
      keywords: "پژوهیار",
    },
  },
};

const ACCEPTABLE_BROWSERS = ["chrome", "firefox", "edge"];

const Extension = () => {
  const { hash } = useLocation();

  const tab = hash
    ? hash.replace("#", "").toLocaleLowerCase()
    : browserName.toLowerCase();

  const defaultTab = ACCEPTABLE_BROWSERS.includes(tab) ? tab : "chrome";

  return (
    <DocumentMeta {...page_meta}>
      <HeaderBanner
        header_color="#eee"
        image={Addon}
        title={title}
        body={body}
      />
      <Row className="justify-content-center mx-0" style={{ marginTop: 20 }}>
        <Col md={8} sm={12}>
          <p className="text-center">
            با توجه به مرورگر مورد استفاده خود افزونه پژوهیار را نصب کنید. برای
            اطلاع بیشتر از افزونه مرورگرهای پژوهیار، می‌توانید به
            <Link to="/help/14"> راهنمای افزونه‌های پژوهیار </Link> مراجعه کنید.
            همچنین می‌توانید برای مشاهده فهرست پایگاه‌های اطلاعاتی که امکان
            ذخیره منابع را با استفاده از افزونه‌ها را به شما می‌دهند، به صفحه
            <Link to="/supported-sites"> پایگاه پشتیبانی شده </Link> پژوهیار
            مراجعه کنید.
          </p>
        </Col>
      </Row>
      <Row className="justify-content-center mx-0">
        <Col>
          <Tabs
            defaultActiveKey={defaultTab}
            id="uncontrolled-tab-example"
            className="extensions-download-links justify-content-center"
            style={{ marginTop: 20 }}>
            <Tab
              eventKey="firefox"
              title={
                <span className="addon-tabs">
                  <img alt="firefox" src={FireFox} />
                </span>
              }>
              <Row style={{ padding: "20px 10px" }}>
                <Col>
                  <Row
                    className="justify-content-center"
                    style={{ padding: "20px 0" }}>
                    افزونه فایرفاکس امکان ذخیره نتایج حاصل از تحقیقات شما را در
                    قالب مترجم‌های شناخته شده در پژوهیار فراهم می‌کند.
                  </Row>

                  <Row
                    className="justify-content-center"
                    style={{ padding: "20px 0" }}>
                    <Button
                      variant="success"
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://addons.mozilla.org/en-US/firefox/addon/pajoohyar/?src=search">
                      دانلود از فایرفاکس
                    </Button>
                  </Row>
                </Col>
              </Row>
            </Tab>
            <Tab
              eventKey="chrome"
              title={
                <span className="addon-tabs">
                  <img alt="chrome" src={Chrome} />
                </span>
              }>
              <Row style={{ padding: "20px 10px" }}>
                <Col>
                  <Row
                    className="justify-content-center"
                    style={{ padding: "20px 0" }}>
                    افزونه کروم امکان ذخیره نتایج حاصل از تحقیقات شما را در قالب
                    مترجم‌های شناخته شده در پژوهیار فراهم می‌کند.
                  </Row>

                  <Row
                    className="justify-content-center"
                    style={{ padding: "20px 0" }}>
                    <Button
                      variant="success"
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://chromewebstore.google.com/detail/%D8%B1%D8%A7%D8%A8%D8%B7-%D9%BE%DA%98%D9%88%D9%87%DB%8C%D8%A7%D8%B1/epeaammaiaknlihkglijkmdfcpohgpid?hl=en-US&utm_source=ext_sidebar">
                      دانلود از کروم استور
                    </Button>
                  </Row>
                </Col>
              </Row>
            </Tab>
            <Tab
              eventKey="edge"
              title={
                <span className="addon-tabs">
                  <img
                    alt="edge"
                    src={edge}
                    style={{ width: 100, height: 100 }}
                  />
                </span>
              }>
              <Row style={{ padding: "20px 10px" }}>
                <Col>
                  <Row
                    className="justify-content-center"
                    style={{ padding: "20px 0", textAlign: "right" }}>
                    افزونه Edge امکان ذخیره نتایج حاصل از تحقیقات شما را در قالب
                    مترجم‌های شناخته شده در پژوهیار فراهم می‌کند.
                  </Row>
                  <Row
                    className="justify-content-center"
                    style={{ padding: "20px 0" }}>
                    <Button
                      variant="success"
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://microsoftedge.microsoft.com/addons/detail/%D8%B1%D8%A7%D8%A8%D8%B7-%D9%BE%DA%98%D9%88%D9%87%DB%8C%D8%A7%D8%B1/adcfppnkaeeengcanndhmflboobmhbfa">
                      دانلود از مایکروسافت استور
                    </Button>
                  </Row>
                </Col>
              </Row>
            </Tab>
          </Tabs>
        </Col>
      </Row>
      <Row className="justify-content-center mx-0">
        <Col sm={12} md={8}>
          <p style={{ textAlign: "center" }}>
            با دانلود افزونه پژوهیار می توانید از
            <Link to="/supported-sites"> پایگاه پشتیبانی شده </Link>
            پژوهیار برای ذخیره اطلاعات استفاده کنید.
          </p>
        </Col>
      </Row>
    </DocumentMeta>
  );
};

export default Extension;
